import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * Shell component for /admin/master-data.
 *
 * Renders the pill-tab navigation (currently a single "System To Form Mapping" pill,
 * matching the original AngularJS state `admin.master-data`) and a <router-outlet>
 * for child routes such as /admin/master-data/system-mapping.
 *
 * Behaviour:
 *  - Visiting /admin/master-data directly shows only the pill tab (empty outlet).
 *  - Clicking the pill navigates to /admin/master-data/system-mapping.
 *  - The main /admin tab "Master Data" links straight to /admin/master-data/system-mapping
 *    (configured in AdminShellComponent.buildTabs with parentTab='master-data').
 */
@Component({
    selector: 'gtw-master-data',
    templateUrl: './master-data.component.html',
    styleUrls: ['./master-data.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MasterDataComponent {
  systemMappingHover = false;
}
